export const selectors = {
  subCopy: {
    mobile: "post-card-subcopy-mobile",
    desktop: "post-card-subcopy-desktop",
  },
  cta: "post-card-cta",
};
